import { createShell } from './shell';
import { createSenderPage } from './sender/page';
import { createReceiverPage } from './receiver/page';

const shell = createShell();
shell.pages.sender.appendChild(createSenderPage(shell.setStatus));
shell.pages.receiver.appendChild(createReceiverPage(shell.setStatus));
